import React, { useState, useEffect, useRef } from "react";
import SectionItem from "../OrdersSectionItem";
import CustomButton from "../../../custom/custom-button/CustomButton";
import PlusIcon from "../../../shared/icons/PlusIcon";
import OrdersSectionItemInfoColumn from "./OrdersSectionItemInfoColumn";
import OrdersDatePicker from "../../../orders/date-picker-new";
import OrdersLocationInfo from "../../../orders/location-info";
import CustomSelect from "../../../custom/custom-select";
import { Order } from "../../../../services";
import {t} from "i18next";

const AddIntermediatePoint = ({ countries, setIsOpenAdd, points, setPoints, errors, user, pickUpDate }) => {
  const addIntermediatePoint = () => {
    setPoints((prevPoints) => [
      ...prevPoints,
      {
        country: "",
        city: "",
        address: "",
        shippingDate: null,
        shippingHourFrom: 0,
        shippingHourTo: 0,
        latLng: "",
        type: 1,
        step: prevPoints.length + 2,
        isInterimPoint: false,
        recipientName: "",
        recipientPhoneNumber: "",
        recipientEmail: "",
      },
    ]);
  };

  const deleteIntermediatePoint = (index) => {
    const updatedPoints = [...points];
    updatedPoints.splice(index, 1);
    setPoints(updatedPoints);
  };

  const handlePointChange = (index, field, value) => {
    const updatedPoints = [...points];
    updatedPoints[index][field] = value;
    const recalculatedPoints = updatedPoints.map((point, idx) => ({
      ...point,
      step: idx + 2,
    }));
    setPoints(recalculatedPoints);
  };

  useEffect(() => {
    points.forEach((point, index) => {
      if (point.country && point.country?.id) {
        Order.getCities(point.country.id, user.id)
          .then((response) => {
            const sortedCities = response.data.sort((a, b) =>
              a.name.localeCompare(b.name),
            );
            handlePointChange(index, "cities", sortedCities);

            if (point.tempCityId) {
              const selectedCity = sortedCities.find(city => city.id === point.tempCityId);
              if (selectedCity) {
                handlePointChange(index, "city", selectedCity);
              }
              handlePointChange(index, "tempCityId", "");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }, [JSON.stringify(points.map((point) => point.country))]);

  const getMinimumDateForPoint = (index) => {
    if (index === 0) {
      return pickUpDate;
    } else {
      return points[index - 1]?.shippingDate || pickUpDate;
    }
  };


  return (
    <>
      {points.map((point, index) => (
        <SectionItem
          key={index}
          column={index}
          title={t("intermediatePointTitle")}
          counter={index + 2}
          isShadow
          isDelete
          deleteIntermediatePoint={() => deleteIntermediatePoint(index)}
        >
          <OrdersSectionItemInfoColumn contentGridColumn="1fr 1fr">
            <OrdersSectionItemInfoColumn title={t('ordersCreate.view.label.country')}>
              <CustomSelect
                key={`countries-point-${index}`}
                labelText={t('ordersCreate.view.label.country')}
                placeholder={t('chooseCountry')}
                options={countries}
                defaultValue={point.country}
                onSubmit={(item) => {
                  handlePointChange(index, "country", item);
                  handlePointChange(index, "city", "");
                  handlePointChange(index, "address", "");
                  handlePointChange(index, "recipientName", "");
                  handlePointChange(index, "recipientPhoneNumber", "");
                  handlePointChange(index, "recipientEmail", "");
                }}
                returnObject
                errorText={errors?.[`points_${index + 2}`]?.country}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn title={t('ordersCreate.view.label.city')}>
              <CustomSelect
                labelText={t('ordersCreate.view.label.city')}
                placeholder={t('chooseCity')}
                options={point.cities}
                defaultValue={point.city}
                isDisabled={!point.country}
                onSubmit={(item) => {
                  handlePointChange(index, "city", item);
                  handlePointChange(index, "address", "");
                  handlePointChange(index, "recipientName", "");
                  handlePointChange(index, "recipientPhoneNumber", "");
                  handlePointChange(index, "recipientEmail", "");
                }}
                returnObject
                errorText={errors?.[`points_${index + 2}`]?.city}
              />
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1.3fr"}>
            <OrdersDatePicker
              date={point.shippingDate}
              timeStart={point.shippingHourFrom}
              timeEnd={point.shippingHourTo}
              minDate={getMinimumDateForPoint(index)}
              isSender
              isEditable
              labelText={t('ordersCreate.view.label.deliveryDate')}
              labelTimeStart={t('ordersCreate.view.label.time')}
              labelTimeEnd={t('ordersCreate.view.label.timeUntil')}
              placeholderText={t('ordersCreate.view.placeholder.enterDate')}
              setDate={(item) => handlePointChange(index, "shippingDate", item)}
              setTimeStart={(item) => handlePointChange(index, "shippingHourFrom", item)}
              setTimeEnd={(item) => handlePointChange(index, "shippingHourTo", item)}
              errorDate={errors?.[`points_${index + 2}`]?.shippingDate}
              errorTimeStart={errors?.[`points_${index + 2}`]?.shippingHourFrom}
              errortimeEnd={errors?.[`points_${index + 2}`]?.shippingHourTo}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t('recipient')}
              isEditable
              forceOpenDropdown={!!point.address}
              forceOpenDropdownCount={point.recipientUpdate || 0}
              countries={countries}
              address={point.address}
              countrySelected={point.country}
              citySelected={point.city}
              companyName={point.recipientName}
              phoneNumber={point.recipientPhone}
              onChangeAddress={(item) => handlePointChange(index, "address", item)}
              onRecipientPhone={(item) =>
                handlePointChange(index, "recipientPhoneNumber", item)
              }
              onCoordinates={(item) => handlePointChange(index, "latLng", item)}
              onAddressId={(item) => handlePointChange(index, "addressId", item)}
              onChangeResipient={(item) =>
                handlePointChange(index, "recipientName", item)
              }
              onChangeCountry={(item) => {
                handlePointChange(index, "country", item);
                handlePointChange(index, "city", "");
              }}
              onChangeCity={(city) => {
                handlePointChange(index, "city", city);
              }}
              onRecipientEmail={(item) =>
                handlePointChange(index, "recipientEmail", item)
              }
              errorText={errors?.[`points_${index + 2}`]?.address}
            />
          </OrdersSectionItemInfoColumn>
        </SectionItem>
      ))}

      <SectionItem column={1} isShadow isPSmall isMrAuto>
        <CustomButton
          text={t("ordersCreateDesktopView.button.addIntermediatePoint")}
          prefixStart={<PlusIcon fill="#2857FC" />}
          isUnderline
          isBlueText
          onClick={addIntermediatePoint}
        />
      </SectionItem>
    </>
  );
};

export default AddIntermediatePoint;
